import React, { useEffect, useRef, useState } from 'react';

const ConfigurationBlockCell = ({
	title,
	text,
	link,
	onClickHandler,
	sortType,
	type = 'text',
	id, // only for checkbox
	value, // only for checkbox
	onChange, // only for checkbox
	checked, // only for checkbox
	hoverPopup = null,
	ellipsized = false,
}) => {
	const [isPopupVisible, setIsPopupVisible] = useState(false);
	const timeoutRef = useRef(null);

	const activatePopup = () => {
		clearTimeout(timeoutRef.current);
		setIsPopupVisible(true);
	};

	const deactivatePopup = () => {
		timeoutRef.current = setTimeout(() => {
			setIsPopupVisible(false);
		}, 300); // 300ms delay to allow moving to popup
	};

	useEffect(() => {
		// clear timer on unmount
		return () => clearTimeout(timeoutRef.current);
	}, []);

	let preparedText = text || '#';
	if (type === 'configurationCode') {
		preparedText = <span className="cdr_configuration_code">{preparedText}</span>;
	} else if (type === 'link') {
		preparedText = (
			<a href={link} title={ellipsized ? preparedText : null}>
				{preparedText}
			</a>
		);
	} else if (type === 'checkbox') {
		preparedText = null;
	}

	return (
		<div
			className="configuration_block__cell"
			onMouseOver={activatePopup}
			onFocus={activatePopup}
			onMouseOut={deactivatePopup}
			onBlur={deactivatePopup}
			role="button"
			tabIndex={0}
		>
			{title && (
				<button
					type="button"
					className="configuration_block__title"
					onClick={onClickHandler ? e => onClickHandler(e, sortType) : null}
				>
					{title}
				</button>
			)}
			{preparedText && <div className="configuration_block__text">{preparedText}</div>}
			{type === 'checkbox' && (
				<div className="configuration_block__text">
					<input id={id} type="checkbox" value={value} onChange={onChange} checked={checked} />
				</div>
			)}
			{isPopupVisible && hoverPopup}
		</div>
	);
};

export default ConfigurationBlockCell;
